module.exports = __webpack_public_path__ + "img/arrow-up-left-circle.026e4505.svg";